// @ts-check

export const INCOME = 'income'

export const EXPENSE = 'expense'

export const SALARY = 'salary'

export const INVOICE = 'INVOICE'

export const JOURNAL = 'JOURNAL'

export const BANK_TRANSACTION = 'BANK_TRANSACTION'

export const entrySubtype = Object.freeze({
  BANK_TRANSACTION,
  JOURNAL,
  INVOICE
})

export const entryModel = Object.freeze({
  BANK_TRANSACTION,
  JOURNAL,
  INVOICE
})

export const entryType = Object.freeze({
  EXPENSE,
  INCOME,
  SALARY
})

export const paymentType = Object.freeze({
  BANK_TRANSACTION: 'BANK_TRANSACTION',
  PAYMENT_EVENT: 'PAYMENT_EVENT'
})

export const customerType = Object.freeze({
  PERSON: 1,
  COMPANY: 0
})

export const service = Object.freeze({
  UKKOPRO: 'ukkopro',
  TMI: 'ukkopro',
  TLP: 'tlp',
  OY: 'oy',
  KYY: 'tlp',
  KY: 'ky'
})

export const entryStatus = Object.freeze({
  COMPENSATED: 'COMPENSATED',
  DELETED: 'DELETED',
  INCOMPLETE: 'INCOMPLETE',
  OVERPAID: 'OVER_PAID',
  REJECTED: 'REJECTED', // not really a status
  PARTIALLY_PAID: 'PARTIAL_PAID',
  NOT_PAID: 'UNPAID',
  PAID: 'PAID',
  CREDIT_NOTE: 'CREDIT_NOTE',
  DRAFT: 'DRAFT',
  FINANCING_INCOMPLETE: 'FINANCING_INCOMPLETE',
  FINANCING_PENDING: 'FINANCING_PENDING',
  FINANCING_REJECTED: 'FINANCING_REJECTED',
  FINANCING_APPROVED: 'FINANCING_APPROVED',
  PAYMENT_PROCESSING: 'PAYMENT_PROCESSING'
})

export const supplierType = Object.freeze({
  COMPANY: 'company',
  FINNISH_COMPANY: 'finnish_company',
  EU_COMPANY: 'eu_company',
  OUTSIDE_EU_COMPANY: 'other_company',
  PERSON: 'person',
  UNKNOWN: 'unknown'
})

/** *********
 * USERPILOT *
 ********* */

export const userPilotLink = Object.freeze({
  UKKOPRO: 'Sr3G26T',
  TLP: 'resource_center:UucK1YFXCC',
  OY: 'resource_center:ZmElvDrRKv'
})

/** *********
 * INCOME *
 ********* */

export const incomeItemType = Object.freeze({
  SALES: 'sales',
  OTHER: 'other'
})

export const incomes = Object.freeze({
  SALES: 'sales',
  INSURANCE_COMPENSATION: 'insurance_compensation',
  REFUND_FROM_TAX_ACCOUNT: 'refund_from_tax_account',
  PRIVATE_PLACEMENT: 'private_placement',
  DRAWN_LOAN: 'drawn_loan',
  GRANTS_AND_SUBSIDIES: 'grants_and_subsidies',
  SALE_OF_FIXED_ASSETS: 'sale_of_fixed_assets',
  VAT_REFUND: 'vat_refund',
  TAX_REFUND: 'tax_refund',
  OTHER: 'other'
})

export const incomePostingType = incomes

export const incomesWithZeroVat = Object.freeze([
  incomes.OTHER,
  incomes.PRIVATE_PLACEMENT,
  incomes.REFUND_FROM_TAX_ACCOUNT,
  incomes.INSURANCE_COMPENSATION,
  incomes.VAT_REFUND,
  incomes.TAX_REFUND
])

export const buyerType = Object.freeze({
  PRIVATE: 'private',
  BUSINESS: 'business'
})

export const priceType = Object.freeze({
  FIXED_PRICE: 'FIXED_PRICE',
  USAGE_BASED: 'USAGE_BASED',
  FLAT_PRICE: 'FLAT_PRICE'
})

export const companyOnlyVat0Codes = Object.freeze([
  'construction_work_reverse_charge',
  'international_shipboard_work',
  'vat_directive_reverse_charge',
  'intra_community_supply_of_goods',
  'sale_rent_or_freighting_of_boat_at_least_10m_long',
  'sales_of_services_outside_eu'
])

/** *********
 * EXPENSE *
 ********** */

export const expenses = Object.freeze({
  PRODUCT: 'product',
  SERVICE: 'service',
  MEETING: 'meeting',
  COST_OF_ENTERTAINMENT: 'costofentertainment',
  RENT: 'rent',
  YEL: 'yel',
  LOAN: 'loan',
  VEHICLE: 'vehicle',
  TAX: 'tax',
  WITHDRAWAL: 'withdrawal',
  UOY_SERVICE_AND_PRODUCTS: 'uoy_serviceproduct',
  UOY_PROPERTY_RENT: 'uoy_propertyrent',
  UOY_INSURANCE: 'uoy_insurance',
  UOY_VEHICLE: 'uoy_vehicle',
  UOY_LOAN: 'uoy_loan',
  UOY_SALARY: 'uoy_salary',
  UOY_TAX: 'uoy_tax',
  UOY_TRAVEL: 'uoy_travel',
  UOY_OVER_PAYMENT_REFUND: 'over_payment_refund'
})

export const expensePostingType = expenses

export const expensesWithZeroVat = Object.freeze([
  expenses.YEL,
  expenses.COST_OF_ENTERTAINMENT,
  expenses.LOAN,
  expenses.WITHDRAWAL,
  expenses.TAX
])

/** **************
 * MISCELLANEOUS *
 *************** */

export const entryItemType = Object.freeze({
  ...expensePostingType,
  ...incomePostingType
})

export const vehicleExpenseType = Object.freeze({
  EXPENSE: 'expense',
  PURCHASE: 'purchase',
  RENTAL: 'rental',
  BORROWED_VEHICLE: 'borrowed_vehicle'
})

export const entryCountry = Object.freeze({
  FINLAND: 'finland',
  EU: 'eu',
  OTHER: 'other'
})

export const incomeItemSubtype = Object.freeze({
  OTHER: 'other'
})

export const paymentReductionType = Object.freeze({
  SALES_COMMISSION: 'SALES_COMMISSION',
  DISCOUNT: 'DISCOUNT'
})

export const paymentReductionCountry = Object.freeze({
  FI: 'finland',
  EU: 'eu',
  OTHER: 'other'
})

export const orderEntriesBy = Object.freeze({
  DOCUMENT_DATE: 'document_date',
  CREATED_AT: 'created_at',
  DATE: 'date'
})

export const companyEnum = '0'
export const personEnum = '1'

export const attachmentResourceType = Object.freeze({
  INCOME: 'income',
  EXPENSE: 'expense',
  VEHICLE: 'vehicle'
})

export const companyStatus = Object.freeze({
  ACTIVE: 'active',
  INACTIVE: 'inactive'
})

export const inactivityReason = Object.freeze({
  UNCONFIRMED_DOCUMENT_PERIODS: 'unchecked_document_periods'
})

export const productUnit = Object.freeze({
  PIECE: 'kpl',
  HOUR: 'h'
})

export const countryCodeFinland = 'FI'

export const vehicleState = Object.freeze({
  PENDING_APPROVAL: 'pending_approval',
  PENDING_REMOVAL: 'pending_removal',
  WAITING_FOR_INFORMATION_APPROVAL: 'waiting_for_information_approval',
  WAITING_FOR_INFORMATION_REMOVAL: 'waiting_for_information_removal',
  REMOVED: 'removed',
  APPROVED: 'approved'
})

export const vehicleType = Object.freeze({
  CAR: 'car',
  VAN: 'van',
  TAXI: 'taxi'
})

export const vehicleRemovalType = Object.freeze({
  SALE: 'sale',
  SALVAGE: 'salvage',
  PRIVATE_USE: 'private_use',
  EXCHANGE: 'exchange'
})

export const customerCareEmail = Object.freeze({
  [service.UKKOPRO]: 'asiakaspalvelu@ukkopro.fi',
  [service.TLP]: 'kevytyritys@ukko.fi',
  [service.OY]: 'osakeyhtio@ukko.fi'
})

export const swanAccountStatus = Object.freeze({
  PENDING: 'pending',
  CONNECTED: 'connected',
  CLOSING: 'closing',
  CLOSED: 'closed'
})

export const swanAccountVerificationStatus = Object.freeze({
  NOT_STARTED: 'not_started',
  WAITING_FOR_INFORMATION: 'waiting_for_information',
  PENDING: 'pending',
  VERIFIED: 'verified',
  REFUSED: 'refused'
})

export const bankConnectionType = Object.freeze({
  SWAN: 'swan',
  ENABLE_BANKING: 'enable_banking',
  WEB_SERVICE: 'web_service'
})

export const expensePaymentOptions = Object.freeze({
  ALREADY_PAID: 'already_paid',
  PAY_LATER: 'pay_later',
  SWAN: 'swan'
})

export const swanOnboardingState = Object.freeze({
  ONGOING: 'Ongoing',
  COMPLETED: 'Completed'
})

/** **************
 * MOBILE *
 *************** */

export const mobileTimeouts = Object.freeze({
  SESSION_EXPIRING_THRESHOLD: 14 // Days before showing expiration message
})

/** **************
 * LOCAL STORAGE *
 *************** */

export const LOCAL_STORAGE_KEY_ACCESS_TOKEN = 'ukkopro-access-token'
export const LOCAL_STORAGE_KEY_REFRESH_TOKEN = 'ukkopro-refresh-token'
export const LOCAL_STORAGE_KEY_SESSION_EXPIRATION_TIME =
  'ukkopro-session-expiration-time'
export const LOCAL_STORAGE_KEY_PERSONAL_ACCESS_TOKEN_ID =
  'ukkopro-personal-access-token-id'
export const LOCAL_STORAGE_KEY_MOBILE_USER = 'ukkopro-is-mobile-wrapper-user'
export const LOCAL_STORAGE_KEY_MOBILE_VERSION = 'ukkopro-mobile-wrapper-version'
export const LOCAL_STORAGE_KEY_MOBILE_PLATFORM =
  'ukkopro-mobile-wrapper-platform'
export const LOCAL_STORAGE_KEY_MOBILE_PLATFORM_VERSION =
  'ukkopro-mobile-wrapper-platform-version'
export const LOCAL_STORAGE_KEY_MOBILE_PLATFORM_ANDROID_API =
  'ukkopro-mobile-wrapper-platform-android-api'
export const LOCAL_STORAGE_KEY_COMPANY_ID = 'ukkopro-company-id'
export const LOCAL_STORAGE_KEY_SESSION_IDENTIFIER = 'ukkopro-session-identifier'
export const LOCAL_STORAGE_KEY_PROMOTION_CODE = 'ukkopro-promotion-code'
export const LOCAL_STORAGE_KEY_LANDING_PAGE = 'ukkopro-landing-page'

export const LOCAL_STORAGE_KEY_MOBILE_VERSION_REMIND_LATER_EXPIRATION =
  'ukkopro-mobile-version-remind-later-expiration'

export const OWNER_TYPE_COMPANY = 'company'

export const OWNER_TYPE_SYSTEM = 'system'

/** **************
 * SESSION STORAGE *
 *************** */

export const SESSION_STORAGE_KEY_NEW_PRICING_DIALOG_REMIND_LATER =
  'ukkopro-new-pricing-dialog-remind-later'
